let nf = Intl.NumberFormat('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });

// allow to show/hide products according with the collection id on section collection-slider-with-filters.liquid
function filterSlider(products, collectionId, splideObject, sectionId) {
  //remove all
  while (splideObject.length) splideObject.remove(splideObject.length - 1);
  // display collection selected
  let productsToShow = products.find(product => product.collection_id == collectionId);

  if (productsToShow && productsToShow.products.length) {
    productsToShow.products.forEach(elem => {
      splideObject.add('<li class="splide__slide">' + elem.outerHTML + '</li>');
    });
  }

  splideObject.refresh();

  // highlight the filter selected
  let allFilters = document.querySelectorAll(`.filter-label-${sectionId}`);

  allFilters.forEach(elem => {
    let temp = elem.getAttribute('collection-id');

    if (temp === collectionId) {
      elem.style.fontWeight = '600';
    } else {
      elem.style.fontWeight = 'normal';
    }
  });

  // check the number of products if <= 4 hide next button
  let nextButton = document.querySelector(`#splide-${sectionId} .splide__arrow--next`);
  let prevButton = document.querySelector(`#splide-${sectionId} .splide__arrow--prev`);
  if (splideObject.length <= 4) {
    if (nextButton) nextButton.style.visibility = 'hidden';
    if (prevButton) prevButton.style.visibility = 'hidden';
  } else {
    if (nextButton) nextButton.style.visibility = 'visible';
  }
}

// reorder slides by collection
function reorderSlides(slides) {
  let results = [];
  slides.forEach(elem => {
    let collectionId = elem.getAttribute('collection-id');
    if (!results.find(collection => collection.collection_id == collectionId)) {
      results.push({ collection_id: collectionId, products: [] });
    }
  });
  slides.forEach(elem => {
    let collectionId = elem.getAttribute('collection-id');
    let collectionIndex = results.findIndex(collection => collection.collection_id == collectionId);
    results[collectionIndex].products.push(elem.querySelector('.product-item'));
  });

  return results;
}

function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function openCart() {

  const eventName = 'view_cart';
  getCartForDataLayer(eventName);

  let cartButton = document.querySelector('.product-detail--button');
  if (cartButton) cartButton.style.zIndex = 0;

  // remove scrollbars from body
  document.body.classList.add('body-no-scroll');

  // show drawer and overlay
  document.querySelector('.cart-drawer').classList.add('cart-drawer--show');
  document.querySelector('.div-overlay').classList.add('div-overlay--show');

  getCartInfo();
}

function getCartForDataLayer(eventName) {
  fetch('/cart.js', {
    method: 'GET',
  })
    .then(response => response.json())
    .then(data => {

      const cartValue = data.total_price / 100;
      const items = []
      let index = 0;

      data.items.forEach(item => {
        index++;
        items.push({
          id: item.id,
          title: item.title,
          vendor: item.vendor,
          index: index,
          type: item.product_type,
          price: item.price / 100,
          quantity: item.quantity,
        })
      })
      cartDataLayerPush(items, eventName, cartValue);
  });
}

function getCartTotal() {
  fetch('/cart.js', {
    method: 'GET',
  })
    .then(response => {
      response
        .json()
        .then(result => {
          document.getElementById('cart-drawer__subtitle').style.display = '';
          document.getElementById('cart-drawer__total').style.display = '';
          document.getElementById('cart-gift-wrapping').style.display = '';
          document.getElementById('cart-drawer-total__price').innerHTML = nf.format((result.total_price / 100).toFixed(2));

          if (result.item_count == 0 || (result.item_count == 1 && result.items[0].properties['_isGift'])) {
            document.getElementById('cart-drawer__subtitle').style.display = 'none';
            document.getElementById('cart-drawer__empty').style.display = '';
            document.getElementById('cart-drawer__total').style.display = 'none';
            document.getElementById('cart-gift-wrapping').style.display = 'none';
          }

          if (result.item_count == 1 && result.items[0].properties['_isGift']) {
            removeGiftProduct(result.items[0].id);
          }

          let temp = result.items.find(elem => elem.properties['_isGift']);
          let haveGift = temp ? -1 : 0;

          document.getElementById('cart-count').innerHTML = result.item_count + haveGift;
        })
        .catch(error => {
          console.log('catch', error);
        });
    })
    .catch(error => {
      console.log('catch', error);
    });
}

function addCompareAtPrice(cart) {
  cart.items.forEach(function(item) {
    $.ajax({
      url: '/products/' + item.handle + '.js',
      dataType: 'json',
      async: false,
      success: function(product) {
        product.variants.forEach(function(variant) {
          if (variant.compare_at_price != null && variant.id == item.variant_id) item['compare_at_price'] = variant.compare_at_price;
          else item['compare_at_price'] = 0;
        });
      },
    });
  });

  return cart;
}

function getCartInfo() {
  let customTags = ['<%', '%>'];
  Mustache.tags = customTags;
  let cartDrawerContent = document.querySelector('.cart-drawer__content');
  let templateCart = document.querySelector('#cartTemplate').innerHTML;
  document.getElementById('cart-drawer__spinner').style.display = '';
  let temp = null;

  let products = {
    products: [],
  };

  fetch('/cart.js', {
    method: 'GET',
  })
    .then(response => {
      response
        .json()
        .then(result => {
          let checkGiftWrap = false;
          const resultWithCompareAtPrice = addCompareAtPrice(result);

          if (result.items.length) {
            resultWithCompareAtPrice.items.forEach(oneProduct => {
              if (oneProduct.properties['_isGift']) {
                checkGiftWrap = true;
              } else {
                temp = {
                  image: oneProduct.properties['_image'] ? oneProduct.properties['_image'] : oneProduct.image,
                  title: oneProduct.product_title,
                  price: nf.format((oneProduct.price / 100).toFixed(2)).replace(',', '.'),
                  compareAtPrice: nf.format((oneProduct.compare_at_price / 100).toFixed(2)).replace(',', '.'),
                  productId: oneProduct.id,
                  vendor: oneProduct.vendor,
                  quantity: oneProduct.quantity,
                  discount: nf.format((oneProduct.compare_at_price / 100).toFixed(2)).replace(',', '.'),
                  hasDiscount: oneProduct.compare_at_price != oneProduct.price ? 'has-discount' : '',
                };
                products.products.push(temp);
              }
            });

            temp = Mustache.render(templateCart, products, {}, customTags);

            cartDrawerContent.innerHTML = temp;

            document.getElementById('cart-drawer-total__price').innerHTML = nf.format((result.total_price / 100).toFixed(2)).replace(',', '.');

            document.getElementById('check-gift').checked = checkGiftWrap;
          }

          let tempItemCount = result.item_count;
          let tempGiftCount = 0;
          if (result.item_count == 1 && checkGiftWrap) {
            removeGiftProduct(result.items[0].id);
            tempItemCount = 0;
            tempGiftCount = -1;
          }
          document.getElementById('cart-count').innerHTML = result.item_count + tempGiftCount;

          if (tempItemCount == 0) {
            document.getElementById('cart-drawer__subtitle').style.display = 'none';
            document.getElementById('cart-drawer__empty').style.display = '';
            document.getElementById('cart-drawer__total').style.display = 'none';
            temp = document.getElementById('cart-gift-wrapping');
            if (temp) temp.style.display = 'none';
          } else {
            document.getElementById('cart-drawer__subtitle').style.display = '';
            document.getElementById('cart-drawer__empty').style.display = 'none';
            document.getElementById('cart-drawer__total').style.display = '';
            temp = document.getElementById('cart-gift-wrapping');
            if (temp) temp.style.display = '';
          }

          setTimeout(() => {
            document.getElementById('cart-drawer__spinner').style.display = 'none';
          }, 300);
        })
        .catch(error => {
          console.log('catch', error);
        });
    })
    .catch(error => {
      console.log('catch', error);
    });
}

function addCompareAtPrice(cart) {
  cart.items.forEach(function(item) {
    $.ajax({
      url: '/products/' + item.handle + '.js',
      dataType: 'json',
      async: false,
      success: function(product) {
        product.variants.forEach(function(variant) {
          if (variant.compare_at_price != null && variant.id == item.variant_id) item['compare_at_price'] = variant.compare_at_price;
          else item['compare_at_price'] = 0;
        });
      },
    });
  });

  return cart;
}

function addToCart(variant_id, item_name, affiliation, compare_at, item_brand, item_category, item_variant, price, isGift, image) {
  const addData = {
    id: variant_id,
    product: {
      id: variant_id,
      title: item_name,
      vendor: affiliation,
      discount: (compare_at - price) / 100,
      designer: item_brand,
      type: item_category,
      color: item_variant,
      price: price / 100,
    },
    properties: {
      _isGift: isGift,
      _image: image,
    },
  };

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(addData),
  })
    .then(response => {
      response
        .json()
        .then(result => {
          if (response.status === 200) {
            addToCartDataLayerPush(addData.product);
            closeLeftDrawer();
            openCart();
          } else {
            if (result.description.indexOf('are in your cart') >= 0) {
              openAlert(allInCart);
            } else {
              openAlert(result.description);
            }
          }
        })
        .catch(error => {
          console.log('catch', error);
        });
    })
    .catch(error => {
      console.log('catch', error);
    });
}

function quantityCartItem(productId, minusPlus, isGift, item_title, affiliation, item_compare_at_price, item_price) {
  let currentQuantity = document.getElementById(`Quantity-${productId}`);
  if (currentQuantity || isGift) {
    let currentQuantityValue = 0;
    let eventName = 'remove_from_cart';
    let removeAll = false;
    let itemCompareAtPrice = item_compare_at_price.replace(/\./g, '');
    let itemPrice = item_price.replace(/\./g, '');

    const itemData = {
      id: productId,
      title: String(item_title),
      vendor: affiliation,
      item_price: Number(itemPrice / 100),
      discount: Number((itemCompareAtPrice - itemPrice) / 100),
    };

    if (!isGift) {
      currentQuantityValue = Number(currentQuantity.value);
      if (minusPlus == 0) {
        eventName = 'remove_from_cart';
        removeAll = true;
        adjustQuantityDataLayerPush(itemData, eventName, currentQuantityValue, removeAll);
        currentQuantityValue = 0;
      } else if (minusPlus > 0) {
        eventName = 'add_to_cart';
        removeAll = false;
        adjustQuantityDataLayerPush(itemData, eventName, currentQuantityValue, removeAll);
        currentQuantityValue = currentQuantityValue + 1
      } else if (minusPlus < 0) {
        eventName = 'remove_from_cart';
        removeAll = false;
        adjustQuantityDataLayerPush(itemData, eventName, currentQuantityValue, removeAll);
        currentQuantityValue = currentQuantityValue - 1
      }
    }

    let addData = {
      updates: {
        [productId]: currentQuantityValue,
      },
    };

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(addData),
    })
      .then(response => {
        if (response.status === 200) {
          if (!isGift) {
            currentQuantity.value = currentQuantityValue;

            if (currentQuantityValue <= 0) {
              removeProductFromCart(productId);
            }
          } else {
            document.getElementById('check-gift').checked = false;
          }

          getCartTotal();
        }
      })
      .catch(error => {
        console.log('catch', error);
      });
  }
}

function removeGiftProduct(productId) {
  let addData = {
    updates: {
      [productId]: 0,
    },
  };

  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(addData),
  })
    .then(response => {
      if (response.status === 200) {
        document.getElementById('cart-drawer-total__price').innerHTML = '0.00';
      }
    })
    .catch(error => {
      console.log('catch', error);
    });
}

function removeProductFromCart(productId) {
  document.getElementById(`cart-product-${productId}`).remove();
}

function checkTerms(elem) {
  document.getElementById('cart-checkout-button').disabled = !elem.checked;
}

function addGiftWrap(elem, productId) {
  if (elem.checked) {
    addToCart(productId, 1, true);
  } else {
    quantityCartItem(productId, 0, true);
  }
}

function addClassesHover() {
  document.querySelector('.header-top').classList.remove('header-video-transparent-bg');

  document.querySelectorAll('.header-top .top-menu-links').forEach(elem => elem.classList.remove('header-video-color'));
  document.querySelector('.header-top__language select').classList.remove('header-video-color');
  document.querySelectorAll('.header-top__search-cart .icons').forEach(elem => elem.classList.remove('header-video-color'));
  document.querySelectorAll('.header-top__search-cart .icons div').forEach(elem => elem.classList.remove('header-video-color'));

  document.querySelector('.header-top__search-cart select').classList.remove('header-video-transparent-bg-select');
  document.querySelector('.header-top__burger').classList.remove('header-video-color');
  document.querySelector('.header-top__burger-mobile').classList.remove('header-video-color');
}

function removeClassesHover() {
  document.querySelector('.header-top').classList.add('header-video-transparent-bg');

  document.querySelectorAll('.header-top .top-menu-links').forEach(elem => elem.classList.add('header-video-color'));
  document.querySelector('.header-top__language select').classList.add('header-video-color');
  document.querySelectorAll('.header-top__search-cart .icons').forEach(elem => elem.classList.add('header-video-color'));
  document.querySelectorAll('.header-top__search-cart .icons div').forEach(elem => elem.classList.add('header-video-color'));

  document.querySelector('.header-top__search-cart select').classList.add('header-video-transparent-bg-select');
  document.querySelector('.header-top__burger').classList.add('header-video-color');
  document.querySelector('.header-top__burger-mobile').classList.add('header-video-color');
}

function addGrayColor(element) {
  document.getElementById(element).style.setProperty('color', 'red', '!important');
}

function fetchProductList(url) {
  fetch(url)
    .then(response => response.text())
    .then(responseText => {
      const html = responseText;
      renderProductList(html);
    });
}

// render the products from the fetch response
function renderProductList(html) {
  const innerHTML = new DOMParser().parseFromString(html, 'text/html');

  let products_result = innerHTML.getElementById('products-list-grid');

  let temp = innerHTML.getElementById('pagination-page');
  const tempCurrentPage = temp.getAttribute('current-page');

  if (products_result) {
    let tempDiv = document.createElement('div');
    tempDiv.innerHTML = products_result.innerHTML;
    document.getElementById('products-list-grid').append(...products_result.childNodes);
    document.getElementById('not-products-found').style.display = 'none';
    let temp = document.getElementById('collections__list');
    if (temp) temp.style = '';
    current_page = tempCurrentPage;
  } else {
    // check if we reached the final pagination page or not products were found
    const checkEnd = innerHTML.getElementById('pagination-end');
    let checkEndText = checkEnd.innerHTML.toUpperCase();
    if (checkEndText == 'END') {
    } else {
      document.getElementById('not-products-found').style.display = 'flex';
      let temp = document.getElementById('collections__list');
      if (temp) temp.style.display = 'none';
    }
    current_page = -1;
  }


  document.querySelector('.collections__spinner').style.display = 'none';
  // set the flag to allow another request
  waitFetch = false;
}

document.addEventListener("DOMContentLoaded", function () {
  const cartCheckoutButton = document.getElementById("cart-checkout-button");
  const eventName = 'begin_checkout';

  if (cartCheckoutButton) {
    cartCheckoutButton.addEventListener("click", function (event) {
      if (!cartCheckoutButton.disabled) {
        getCartForDataLayer(eventName);
      }
    });
  }
});

function toggleVolumeIcon(id) {
  const videoElements = document.querySelectorAll(`#video-${id}`);

  videoElements.forEach(videoElement => {
    videoElement.muted = !videoElement.muted;

    if (videoElement.muted) {
      videoElement.parentElement.querySelector('.volume-on').classList.add('banner__button-muted--hide');
      videoElement.parentElement.querySelector('.volume-muted').classList.remove('banner__button-muted--hide');
    } else {
      videoElement.parentElement.querySelector('.volume-on').classList.remove('banner__button-muted--hide');
      videoElement.parentElement.querySelector('.volume-muted').classList.add('banner__button-muted--hide');
    }
  });

}